import { defineMessages } from "react-intl";

const messages = defineMessages({
    cropScore: {
        id: "tasks.barSorting.cropScore",
    },
    stopEdit: {
        id: "tasks.stopEdit",
    },
    loading: {
        id: "general.loading",
    },
    deleteAudio: {
        id: "general.deleteAudio",
    },
    uploadAudio: {
        id: "general.uploadAudio",
    },
    fileUpload: {
        id: "general.fileUpload",
    },
    fileTooLarge: {
        id: "general.fileTooLarge",
    },
    fileIncorrectFormat: {
        id: "general.fileIncorrectFormat",
    },
    uploadMp3: {
        id: "general.uploadMp3",
    },
    fileSizeLimit: {
        id: "general.fileSizeLimit",
    },
    close: {
        id: "general.close",
    },
    uploadAudioInProgress: {
        id: "general.uploadAudio.inProgress",
    },
});

export default messages;
